abbr:
  AAAI: Proceedings of the AAAI Conference on Artificial Intelligence
  IJCAI: Proceedings of the International Joint Conference on Artificial Intelligence
  IROS: Proceedings of the IEEE/RSJ International Conference on Intelligent Robots and Systems
  ICRA: Proceedings of the IEEE International Conference on Robotics and Automation
  ICAPS: Proceedings of the International Conference on Automated Planning and Scheduling
  AAMAS: Proceedings of the International Conference on Autonomous Agents and Multiagent Systems
  SoCS: Proceedings of the International Symposium on Combinatorial Search
  CoRL: Proceedings of the Conference on Robot Learning
  VTC: Proceedings of the IEEE Vehicular Technology Conference
  RA-L: IEEE Robotics and Automation Letters
  T-RO: IEEE Transactions on Robotics
  AIJ: Artificial Intelligence
  JRM: Journal of Robotics and Mechatronics
  WoMAPF: Proceedings of the Workshop on Multi-Agent Path Finding
  iCAST: Proceedings of the International Conference on Awareness Science and Technology
  ICLR: Proceedings of the International Conference on Learning Representations
